export default "__VITE_ASSET__775vuKy___"